import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
const reviews = [{
  name: 'Mateo G.',
  age: 28,
  location: 'CDMX',
  photo: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=200&h=200&fit=crop&crop=faces',
  quote: 'Dejé de apostar por instinto. Ahora leo el partido desde la estructura — todo cambia.',
  stars: 5
}, {
  name: 'Diego F.',
  age: 34,
  location: 'Santiago',
  photo: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&h=200&fit=crop&crop=faces',
  quote: 'La diferencia entre adivinar y decidir con datos reales. VISIONGOL me cambió la cabeza.',
  stars: 5
}, {
  name: 'Santiago L.',
  age: 25,
  location: 'Lima',
  photo: 'https://images.unsplash.com/photo-1531427186611-ecfd6d936c79?w=200&h=200&fit=crop&crop=faces',
  quote: 'Lo que más valoro es la calma. Ya no reacciono — analizo. Y los resultados hablan.',
  stars: 5
}, {
  name: 'Andrés R.',
  age: 31,
  location: 'Bogotá',
  photo: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=200&h=200&fit=crop&crop=faces',
  quote: 'El nivel de análisis es de otro mundo. Es como tener un equipo de scouts trabajando 24/7.',
  stars: 5
}, {
  name: 'Carlos M.',
  age: 38,
  location: 'Madrid',
  photo: 'https://images.unsplash.com/photo-1492562080023-ab3db95bfbce?w=200&h=200&fit=crop&crop=faces',
  quote: 'Después de años de perder por emoción, por fin entendí lo que faltaba: contexto.',
  stars: 5
}, {
  name: 'Sebastián C.',
  age: 26,
  location: 'Buenos Aires',
  photo: 'https://images.unsplash.com/photo-1463453091185-61582044d556?w=200&h=200&fit=crop&crop=faces',
  quote: 'Empecé escéptico. A las 2 semanas, no podía ver un partido sin abrir el terminal.',
  stars: 5
}, {
  name: 'Javier P.',
  age: 33,
  location: 'Caracas',
  photo: 'https://images.unsplash.com/photo-1539571696357-5a69c17a67c6?w=200&h=200&fit=crop&crop=faces',
  quote: 'La forma en que detecta señales que nadie está viendo… es lo que más me sorprende.',
  stars: 5
}, {
  name: 'Nicolás H.',
  age: 22,
  location: 'Medellín',
  photo: 'https://images.unsplash.com/photo-1521119989659-a83eee488004?w=200&h=200&fit=crop&crop=faces',
  quote: 'Ya no apuesto más — decido. Esa frase resume todo lo que cambió en mi forma de jugar.',
  stars: 5
}, {
  name: 'Fernando B.',
  age: 36,
  location: 'Guadalajara',
  photo: 'https://images.unsplash.com/photo-1480455624313-e29b44bbfde1?w=200&h=200&fit=crop&crop=faces',
  quote: 'Por fin una herramienta que se siente seria. No promete nada — entrega claridad.',
  stars: 5
}, {
  name: 'Lucas Y.',
  age: 29,
  location: 'Arequipa',
  photo: 'https://images.unsplash.com/photo-1522075469751-3a6694fb2f61?w=200&h=200&fit=crop&crop=faces',
  quote: 'Lo recomiendo no por las predicciones, sino por cómo enseña a leer el juego de verdad.',
  stars: 5
}, {
  name: 'Ricardo S.',
  age: 32,
  location: 'Asunción',
  photo: 'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=200&h=200&fit=crop&crop=faces',
  quote: 'Aposté con claridad por primera vez. Material real y confiable — finalmente generé ingresos consistentes.',
  stars: 5
}, {
  name: 'Eduardo M.',
  age: 27,
  location: 'San José',
  photo: 'https://images.unsplash.com/photo-1488161628813-04466f872be2?w=200&h=200&fit=crop&crop=faces',
  quote: 'Información seria, datos confiables. Apuesto con cabeza fría y los ingresos llegan solos.',
  stars: 5
}, {
  name: 'Adrián W.',
  age: 24,
  location: 'Valparaíso',
  photo: 'https://images.unsplash.com/photo-1504257432389-52343af06ae3?w=200&h=200&fit=crop&crop=faces',
  quote: 'Nunca vi material tan bien estructurado. Ahora aposté con claridad y empecé a generar ingresos reales.',
  stars: 5
}, {
  name: 'Tomás Q.',
  age: 35,
  location: 'Rosario',
  photo: 'https://images.unsplash.com/photo-1502720433255-614171a1835e?w=200&h=200&fit=crop&crop=faces',
  quote: 'Datos reales, no humo. Por fin tengo una herramienta confiable que me ayuda a tomar decisiones rentables.',
  stars: 5
}, {
  name: 'Bruno X.',
  age: 30,
  location: 'Mérida',
  photo: 'https://images.unsplash.com/photo-1496345875659-11f7dd282d1d?w=200&h=200&fit=crop&crop=faces',
  quote: 'Material confiable, análisis serio. Cambió completamente mi forma de apostar — y se nota en los ingresos.',
  stars: 5
}, {
  name: 'Gabriel E.',
  age: 39,
  location: 'Valencia',
  photo: 'https://images.unsplash.com/photo-1519345182560-3f2917c472ef?w=200&h=200&fit=crop&crop=faces',
  quote: 'Apuesto con claridad porque tengo datos reales. Es la primera vez que la información que pago vale lo que cuesta.',
  stars: 5
}, {
  name: 'Pablo Z.',
  age: 23,
  location: 'Sevilla',
  photo: 'https://images.unsplash.com/photo-1492447166138-50c3889fccb1?w=200&h=200&fit=crop&crop=faces',
  quote: 'Generé ingresos desde la primera semana. No por suerte — por seguir el análisis estructurado de la IA.',
  stars: 5
}];
const loopedReviews = [...reviews, ...reviews];
export function PredictionDashboard() {
  return <motion.div initial={{
    opacity: 0,
    scale: 0.95
  }} animate={{
    opacity: 1,
    scale: 1
  }} transition={{
    duration: 0.8,
    ease: 'easeOut'
  }} className="w-full relative" data-id="element-155">
      {/* Header */}
      <div className="flex items-center justify-between mb-5 px-1 gap-3" data-id="element-156">
        <div className="flex items-center gap-2 min-w-0" data-id="element-157">
          <div className="w-2 h-2 rounded-full bg-brand-green animate-pulse shrink-0" data-id="element-158" />
          <span className="text-xs font-mono text-brand-green tracking-wider uppercase truncate" data-id="element-159">
            Reviews verificadas
          </span>
          <span className="text-xs font-mono text-white/90 bg-brand-green/10 border border-brand-green/30 rounded-md px-2 py-0.5 shrink-0" data-id="element-160">
            2,399
          </span>
        </div>
        <div className="flex items-center gap-1 shrink-0" data-id="element-161">
          {[...Array(5)].map((_, i) => <Star key={i} className="w-3.5 h-3.5 fill-brand-gold text-brand-gold" data-id="element-162" />)}
          <span className="text-xs text-gray-400 font-mono ml-1" data-id="element-163">4.9</span>
        </div>
      </div>

      {/* Carousel container */}
      <div className="relative w-full overflow-hidden" data-id="element-164">
        {/* Edge fades */}
        <div className="absolute left-0 top-0 bottom-0 w-12 bg-gradient-to-r from-brand-bg to-transparent z-10 pointer-events-none" data-id="element-165" />
        <div className="absolute right-0 top-0 bottom-0 w-12 bg-gradient-to-l from-brand-bg to-transparent z-10 pointer-events-none" data-id="element-166" />

        <div className="flex gap-4 animate-scroll-x w-max py-2" data-id="element-167">
          {loopedReviews.map((r, i) => <div key={i} className="glass-panel rounded-2xl p-5 w-[280px] shrink-0 border-white/10" data-id="element-168">
              <div className="flex items-start justify-between mb-4" data-id="element-169">
                <div className="flex items-center gap-3" data-id="element-170">
                  <img src={r.photo} alt={r.name} className="w-11 h-11 rounded-full object-cover border border-brand-blue/30" loading="lazy" data-id="element-171" />
                  <div data-id="element-172">
                    <div className="text-sm font-display font-bold text-white" data-id="element-173">
                      {r.name}
                    </div>
                    <div className="text-[11px] text-gray-500 font-mono" data-id="element-174">
                      {r.age} · {r.location}
                    </div>
                  </div>
                </div>
                <Quote className="w-4 h-4 text-brand-blue/40 shrink-0" data-id="element-175" />
              </div>

              <div className="flex gap-0.5 mb-3" data-id="element-176">
                {[...Array(r.stars)].map((_, j) => <Star key={j} className="w-3 h-3 fill-brand-gold text-brand-gold" data-id="element-177" />)}
              </div>

              <p className="text-sm text-gray-300 leading-relaxed" data-id="element-178">
                "{r.quote}"
              </p>
            </div>)}
        </div>
      </div>

      {/* Footer note */}
      <div className="flex items-center justify-center gap-2 mt-4 text-[11px] text-gray-500 font-mono uppercase tracking-wider" data-id="element-179">
        <span className="w-1 h-1 rounded-full bg-brand-green" data-id="element-180" />
        +12,000 análisis realizados
      </div>
    </motion.div>;
}